import React from "react";
import {Badge, ButtonGroup, ButtonGroupButton} from "peggirkit";
import {OptionGroup} from "@/data/entities/option";

type Props = {
    optionGroups: OptionGroup[],
    isFetching: boolean,
};

const OptionGroupsList = ({optionGroups, isFetching}: Props) => {
    return (
        <ButtonGroup
            vertical
            variant={"solid"}
            containerClassName={"w-full"}
        >
            {optionGroups.map((group: OptionGroup) =>
                <ButtonGroupButton
                    key={group.id}
                    disabled={isFetching}
                    buttonAction={{
                        as: "button",
                        actionProps: {
                            onClick: e => {
                                e.preventDefault();
                                if (!isFetching) {
                                    document
                                        .querySelector(`li[data-option-group-id="${group.id}"]`)
                                        ?.scrollIntoView({behavior: "smooth"});
                                }
                            }
                        },
                    }}
                >
                    <span className={"block truncate pr-10"}>
                        {group.name}
                    </span>
                    <Badge
                        size={"xs"}
                        radius={"chip"}
                        containerClassname={"absolute right-4 top-1/2 -translate-y-1/2"}
                    >
                        {group.optionIds.length}
                    </Badge>
                </ButtonGroupButton>
            )}
        </ButtonGroup>
    );
};

export default OptionGroupsList;